import {AxiosError} from 'axios';
import {useQueryClient} from 'react-query';
import {UpdateAdminProfileDetailsRequest} from '../../api/user/model';
import {POST_PUT_ADMIN_PROFILE_DETAIL_URL} from '../../constants/apiUrls';
import {GET_ADMIN_PROFILE_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutAdminProfileDetails = ({onSuccess, onError}: Input = {}) => {
  const queryClient = useQueryClient();

  const putAdminProfileDetails = async (reqBody: UpdateAdminProfileDetailsRequest) => {
    await axiosClient.put(POST_PUT_ADMIN_PROFILE_DETAIL_URL, reqBody);
  };

  return useCustomMutation(putAdminProfileDetails, {
    onSuccess: () => {
      queryClient.invalidateQueries(GET_ADMIN_PROFILE_DETAILS_QUERY_KEY);
      onSuccess?.();
    },
    onError,
  });
};
